import { importLibrary, setOptions } from "@googlemaps/js-api-loader";
import { publicConfigValue } from "@/lib/public-config";

let optionsApplied = false;

export function hasGoogleMapsKey(): boolean {
  return Boolean(publicConfigValue("NEXT_PUBLIC_GOOGLE_MAPS_API_KEY"));
}

function ensureOptions(): boolean {
  const apiKey = publicConfigValue("NEXT_PUBLIC_GOOGLE_MAPS_API_KEY");
  if (!apiKey) return false;
  if (!optionsApplied) {
    setOptions({
      key: apiKey,
      v: "weekly",
      region: "US",
      libraries: ["places"],
    });
    optionsApplied = true;
  }
  return true;
}

export function loadPlacesLibrary(): Promise<google.maps.PlacesLibrary> {
  if (!ensureOptions()) {
    return Promise.reject(new Error("NEXT_PUBLIC_GOOGLE_MAPS_API_KEY is not set"));
  }
  return importLibrary("places");
}

export function loadGeocodingLibrary(): Promise<google.maps.GeocodingLibrary> {
  if (!ensureOptions()) {
    return Promise.reject(new Error("NEXT_PUBLIC_GOOGLE_MAPS_API_KEY is not set"));
  }
  return importLibrary("geocoding");
}
